module.exports = __webpack_public_path__ + "static/media/doorEndCap.88543f5e.png";